import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import SelectInvoiceSerie from 'Components/Organisms/SelectInvoiceSerie/SelectInvoiceSerie';

export default function RHFSelectInvoiceSerie({ name, ...other }) {
    const { control, clearErrors } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
                useEffect(() => {
                    if (field.value && error) {
                        clearErrors(name);
                    }
                }, [name, field.value, clearErrors]);

                return <SelectInvoiceSerie {...field} error={error?.message} {...other} />;
            }}
        />
    );
}

RHFSelectInvoiceSerie.propTypes = {
    name: PropTypes.string.isRequired,
};
